<template>
  <div>
    <div v-for="local in localKeys">
      <div v-if="!spec.present" class="text-muted">{{local}}</div>
      <component :is="_spec(local).component"
                 ref="field"
                 :name="_spec(local).prop"
                 :spec="_spec(local)"
                 :model="model"
                 :$parentForm="$parentForm"
                 :rootModel="rootModel"
                 :$rootForm="$rootForm"
                 :readonly="_readonly"
                 :key="_spec(local).prop">
      </component>
    </div>
  </div>
</template>

<script>
  import {assign, every, get, map} from 'lodash';
  import mixin from './mixin';
  import {Validator} from 'vee-validate';
  import i18n from 'src/i18n';
  import {sanitizeModel} from 'src/schemas/utils';

  export default {
    name: 'f-i18n',
    mixins: [mixin],
    data() {
      return {};
    },
    computed: {
      localKeys() {
        if (this.spec.local) {
          return Array.isArray(this.spec.local) ? this.spec.local : [this.spec.local];
        } else if (this._readonly) {
          return [this.i18n.local];
        }
        return this.i18n.langs;
      },
    },
    methods: {
      _spec(local) {
        return {
          ...this.spec.itemType,
          prop: this.spec.prop + (this.spec.separator == null ? '.' : this.spec.separator) + local,
        };
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-i18n.vue?054c5a16